// Shared loyalty logic — mirrors backend `_loyalty_discount` in /app/backend/server.py
export const LOYALTY_SILVER_MIN = 250;
export const LOYALTY_GOLD_MIN = 1100;
export const LOYALTY_ELITE_MONTHLY_MIN = 10000;

export const LOYALTY_TIER_META = {
  none:   { label: "",                  percent: 0,  color: "#78716c" },
  silver: { label: "10% loyalty",       percent: 10, color: "#D96C4A" },
  gold:   { label: "15% loyalty",       percent: 15, color: "#B8860B" },
  elite:  { label: "Elite · 20% off",   percent: 20, color: "#1A362B" },
};

export function computeLoyalty(subtotal, monthlySpend = 0) {
  let percent = 0;
  let tier = "none";
  if (monthlySpend >= LOYALTY_ELITE_MONTHLY_MIN) {
    percent = 20; tier = "elite";
  } else if (subtotal >= LOYALTY_GOLD_MIN) {
    percent = 15; tier = "gold";
  } else if (subtotal >= LOYALTY_SILVER_MIN) {
    percent = 10; tier = "silver";
  }
  const amount = Math.round(subtotal * percent) / 100;
  return { amount, tier, percent };
}
